// extracted by mini-css-extract-plugin
export default {"container":"TypeaheadResultSubtitle_container__E-Tqv","isMobile":"TypeaheadResultSubtitle_isMobile__uANR9"};